import(/* webpackMode: "eager" */ "/vercel/path0/apps/studio-web/app/[domain]/error.tsx");
